// 限时闯关 分享加次数
var LightningRushRedirector = xClass("LightningRushRedirector", BaseRedirector)
LightningRushRedirector.prototype.getName = function () {
    var self = this
    return "lightningRush"
}
LightningRushRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
LightningRushRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    var um = UserManager.getInstance();
    console.log("lightningRush LightningRushRedirector um.settings",um.settings)
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }

    //  检查是否为点自己的链接
    let uid = um.uid;
    let inviteCode = param["inviteCode"] == null? null: +param["inviteCode"];
    let isMythis = inviteCode === uid || false;
    if (isMythis) {
        Toast.make(getText("coin.match.share.self"));
        return true;
    }
    
    let needCheckNewUser = true
    //  检查是否为新玩家
    if (needCheckNewUser) {
        if (!_G.kIsNewUser) {
            console.log("不是新玩家");
            return true;
        } else if (_G.isGetNewUserReward) {
            console.log("大哥你别想着刷奖了");
            return true;
        } else {
            console.log("是新玩家");
        } 
    }

    console.log("lightningRush LightningRushRedirector param",param)

    if (um.uid && param.inviteCode && param.shareId) {
        let http = RushLimitShareClickHttp.new();
        http.addEventListener(Events.kComplete, () => {
            Toast.make(getText("邀请成功！好友已获取闯关次数~"));
            _G.isGetNewUserReward = true;
        })
        http.addEventListener(Events.kError, (evt = {}) => {
            // Toast.make(quickGetErrorText(evt.data, "帮助链接已经失效！"));
            if (evt.data){
                Toast.make(getText("error.tip."+evt.data.toString()));
            }
        })
        http.load(param.inviteCode, param.shareId);
    }
    return true
}
module.exports = LightningRushRedirector
